
const digest = '1e320b795be258ae5bcf0e8b9f684d27fd5369bceb2fca9cdaee437837413233';
const classes = {"wrapper":"_wrapper_1cxht_1","groupName":"_groupName_1cxht_7"};
const css = `._wrapper_1cxht_1 {
  font-family: Rubik, "sans-serif";
  padding: 10px;
  border-left: 1px solid #ccc;
  margin: 20px 12px;
}
._wrapper_1cxht_1 ._groupName_1cxht_7 {
  font-size: 12px;
  font-weight: 500;
  padding: 0 12px;
  margin-bottom: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  